import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withT } from '~app/core/BundleProvider';
import { registerHotkey, unregisterHotkey } from '~app/core/useGlobalHotkey';
import { actions as DocumentActions } from '~app/features/document';
import { connect } from 'react-redux';
import { compose } from 'redux';

class FileSubmit extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    type: PropTypes.string,
    extension: PropTypes.string,
  };

  state = {
    creator: '',
    showError: false,
  };

  hotkeyCb() {
    this.props.onCancel();
  }

  componentDidMount() {
    this.hotkeyId = registerHotkey({
      hotkey: 'Escape',
      callback: () => this.hotkeyCb(),
      event: 'keyup',
      priority: 8,
      stop: true,
    });
  }

  componentWillUnmount() {
    unregisterHotkey(this.hotkeyId);
  }

  handleChange = e => {
    this.setState({ creator: e.target.value });
  };

  handleSubmit = () => {
    this.props.setNewUUID();
    let cname = this.state.creator;
    // Add underscore in front of name and remove extra spaces with underscores
    cname = '_' + cname.replace(/\s+/g, ' ').trim().replace(/ /g, '_');
    // Validate file name
    let validFilename = /^[\w_@() -][.\w_@() -]*$/.test(cname);
    if (validFilename && cname !== '') {
      if (this.props.creatorName.length === 0) {
        cname =
          this.props.fileInfo?.name.substring(
            0,
            this.props.fileInfo?.name.lastIndexOf('.'),
          ) +
          cname +
          '.model';
      } else {
        cname =
          this.props.fileInfo?.name.substring(
            0,
            this.props.fileInfo?.name.indexOf('assessment_') +
              'assessment_'.length -
              1,
          ) +
          cname +
          '.model';
      }
      this.props.setCreatorName(this.state.creator);
      this.setState({ showError: false });
      this.props.handleSubmit(cname);
    } else {
      // Notify the user of an invalid file name
      this.setState({ showError: true });
    }
  };

  render() {
    const { t } = this.props;
    return (
      <div className="FileSubmit">
        <h1 className="FileSubmit__title">{t('save-model')}</h1>
        <h2 className="FileSubmit__subtitle">{t('save-model-instructions')}</h2>
        <h2 className="FileSubmit__subtitle">
          {t('save-model-instructions-warning')}
        </h2>
        <div className="FileSubmit__input-subtitle">
          {this.props.creatorName.length === 0
            ? this.props.fileInfo?.name.substring(
                0,
                this.props.fileInfo?.name.lastIndexOf('.'),
              ) + '_'
            : this.props.fileInfo?.name.substring(
                0,
                this.props.fileInfo?.name.indexOf('assessment_') +
                  'assessment_'.length -
                  1,
              ) + '_'}
          <input
            className="FileSubmit__input"
            placeholder={t('submit-placeholder')}
            onChange={this.handleChange}
            aria-label={t('file-name-input')}
            value={this.state.creator}
          />
        </div>
        {this.state.showError && (
          <div className="FileSubmit__error">{t('invalid-file-name')}</div>
        )}
        <div className="FileSubmit__button-group">
          <div
            className="FileSubmit__button-cancel"
            onClick={this.props.onCancel}
            role="button"
            tabIndex={0}
          >
            {t('cancel-button')}
          </div>
          <div
            className={
              this.state.creator.length === 0
                ? 'FileSubmit__button-disabled'
                : 'FileSubmit__button'
            }
            onClick={this.state.creator.length === 0 ? null : this.handleSubmit}
            role="button"
            tabIndex={0}
          >
            {t('save-and-download')}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ document, canvas }) => ({
  creatorName: document.present?.creator,
  fileInfo: canvas.fileInfo,
});

const mapDispatchToProps = {
  setCreatorName: DocumentActions.setCreatorName,
  setNewUUID: DocumentActions.setNewUUID,
};

export default compose(
  withT,
  connect(mapStateToProps, mapDispatchToProps),
)(FileSubmit);
